'use client';

import React from 'react';

import classNames from 'classnames';
import { useTranslations } from 'next-intl';

import { Container } from '@/blocks/components/Container';
import { IconEmail } from '@/blocks/components/Icons/IconEmail';
import { IconHelp } from '@/blocks/components/Icons/IconHelp';
import { IconMenuChat } from '@/blocks/components/Icons/IconMenuChat';
import { ShowIntercomBtn } from '@/blocks/components/Intercom/Launchers';
import { HelpCenterLink } from '@/blocks/components/PlatformLink/HelpCenter';
import { LinkEmail } from '@/blocks/components/PlatformLink/LinkEmail';
import { TopIconCard, TopIconCardProps } from '@/blocks/components/TopIconCard';
import { Section } from '@/blocks/components/layout';
import { CardsGrid } from '@/blocks/components/layout/CardsGrid';
import { emailSupport } from '@/global/public-settings';
import { EventBlockNames } from '@/providers/analytics/types';
import links from '@/styles/link.module.scss';
import typography from '@/styles/typography.module.scss';
import { getStringHtmlTagsValues } from '@/utils/string/getStringHtmlTagsValues';

export function ComplaintsStatsSection() {
  const tr = useTranslations();

  // const cardsData: TopIconCardProps[] = [
  //   {
  //     title: tr.rich('pages.complaints.sections.reachVariants.cards.0.title'),
  //     description: tr.rich('pages.complaints.sections.reachVariants.cards.0.description', {
  //       a: (content) => (
  //         <button
  //           className={classNames(links.textLink)}
  //           onClick={() => {
  //             show();
  //           }}
  //         >
  //           {content}
  //         </button>
  //       ),
  //     }),
  //     icon: <IconChat />,
  //     iconBg: 'orange',
  //   },
  //   {
  //     title: tr.rich('pages.complaints.sections.reachVariants.cards.1.title'),
  //     description: tr.rich('pages.complaints.sections.reachVariants.cards.1.description', {
  //       a: (content) => (
  //         <HelpCenterLink
  //           data-event-label={
  //             getStringHtmlTagsValues(
  //               tr.raw('en.pages.complaints.sections.reachVariants.cards.1.description'),
  //             ).a
  //           }
  //           className={classNames(buttons.btn, buttons.btnLink)}
  //         >
  //           {content}
  //         </HelpCenterLink>
  //       ),
  //     }),
  //     icon: <IconHelp />,
  //   },
  // ];

  const cards: TopIconCardProps[] = [
    {
      title: tr.rich('pages.about.contactUs.sections.reachVariants.cards.0.title'),
      description: tr.rich('pages.about.contactUs.sections.reachVariants.cards.0.description', {
        a: (content) => (
          <ShowIntercomBtn className={classNames(links.textLink, links.underline)}>{content}</ShowIntercomBtn>
        ),
      }),
      icon: <IconMenuChat />,
      iconBg: 'orange',
    },
    {
      title: tr.rich('pages.about.contactUs.sections.reachVariants.cards.3.title'),
      description: tr.rich('pages.about.contactUs.sections.reachVariants.cards.3.description', {
        a: (content) => (
          <HelpCenterLink
            data-event-label={getStringHtmlTagsValues(tr.raw('en.sections.cta.footnote')).a}
            className={classNames(links.textLink, links.underline)}
          >
            {content}
          </HelpCenterLink>
        ),
      }),
      icon: <IconHelp />,
      iconBg: 'violet',
    },
    {
      title: tr.rich('pages.about.contactUs.sections.reachVariants.cards.1.title'),
      description: tr.rich('pages.about.contactUs.sections.reachVariants.cards.1.description', {
        a: (content) => (
          <LinkEmail
            className={classNames(links.textLink, links.underline, links.breakWord)}
            email={emailSupport}
          />
        ),
        // br: () => null,
      }),
      icon: <IconEmail />,
      iconBg: 'primary',
    },
  ];

  return (
    <Section marginType={'margin'}>
      <Container data-event-block-name={EventBlockNames.icon_card_list}>
        <CardsGrid rowAt={'md'}>
          {cards?.map((card, key) => (
            <TopIconCard {...card} key={key} classes={{ description: typography.subheadingM }} />
          ))}
        </CardsGrid>
      </Container>
    </Section>
  );
}
